"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("modal", {
    attrs: {
      show: true,
      "show-close": true
    },
    on: {
      close: _vm.close
    }
  }, [_c("h1", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_vm._v("Adicionar novo serviço a unidade de negócio")]), _vm._v(" "), _c("form", {
    attrs: {
      id: "formNewTypeService"
    }
  }, [_c("app-select", {
    attrs: {
      label: "Serviço",
      placeholder: "Selecione o Serviço",
      error: _vm.$v.form.DigitalAsset.$error,
      items: _vm.listServices,
      option: "DigitalAssetId",
      "name-item": "Name"
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.DigitalAsset, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.DigitalAsset.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.DigitalAsset, "$model", $$v);
      },
      expression: "$v.form.DigitalAsset.$model"
    }
  })], 1), _vm._v(" "), _c("b-button", {
    attrs: {
      slot: "footer",
      type: "is-info"
    },
    on: {
      click: _vm.checkForm
    },
    slot: "footer"
  }, [_vm._v("\n    Salvar\n  ")])], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;